export class TipoOperacion {

  static Retiro;
  static Compra;
  static Deposito;
  constructor() {
    TipoOperacion.Compra = 1;
    TipoOperacion.Deposito = 2;
    TipoOperacion.Retiro = 3;
  }
  get staticDeposito(){
    return TipoOperacion.Deposito;
  }
  get staticRetiro(){
    return TipoOperacion.Retiro;
  }
  get staticCompra(){
    return TipoOperacion.Compra;
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/operaciones/tipoOperacion.model.ts